export const StepType = {
  SUBTASK_TASK_CREATION: 'SUBTASK_TASK_CREATION',
  TASK_SETTINGS: 'TASK_SETTINGS',
  TIME_FRAME_SELECTION: 'TIME_FRAME_SELECTION',
} as const

type StepType = typeof StepType[keyof typeof StepType]

export interface SubtaskBase {
  is_required?: boolean
  title: string
  type: number
  order_index: number
  id?: string
  category?: string
  disable_gallery_upload?: boolean
  reference_images?: string[]
  // AI review of an image subtask. `ai_prompt` is local-only — `submitAllForms` turns it into a real
  // prompt (`message_id`) and strips it from the payload.
  is_ai_enhanced?: boolean
  prompt_id?: string
  message_id?: string
  ai_prompt?: string
  // Content object for Image/Video subtasks
  content?: {
    text?: string
    rich_text?: any | null // EditorContent from RichTextEditor (JSON format)
    images?: string[]
    videos?: string[]
    files?: string[]
  }
}

export interface LinkSubtask extends SubtaskBase {
  external_link?: string
  is_external_status_update?: boolean
}

export interface PollSubtask extends SubtaskBase {
  is_multi_choice?: boolean
  options?: (string | { value: string })[]
}

export interface OpenQuestionSubtask extends SubtaskBase {
  is_numeric: boolean
}

export interface Content {
  id?: string
  type: number
  text: string | null
  rich_text?: any | null // EditorContent from RichTextEditor (JSON format)
  images: string[] | null
  videos: string[] | null
  files: string[] | null
  index_ref: number
}

export type Subtask = SubtaskBase & LinkSubtask & PollSubtask

export type TaskAudience = {
  groups: string[]
  users: string[]
  tags: string[]
}

export type TaskTimeFrame = {
  from_ts: string
  deadline: string | null
  frequency_time: string
  is_recurring: boolean
  monthly_range: string[]
  recurrence_frequency: number | null
  days_of_week: number[] | null
  allowed_overdue_days: number
  review_to_ts?: string | null
}

export type TaskFormData = {
  SUBTASK_TASK_CREATION: {
    title?: string
    sub_tasks: Subtask[]
  }
  TASK_SETTINGS: {
    audience: TaskAudience
    view: number | null
    is_individual_results: boolean
    send_schedule_push: boolean
    from_ts: string
    deadline: string
    allowed_overdue_days: number
    priority: number
    disable_gallery_upload: boolean
    rework_limit: number | null
    allow_completion_after_deadline: boolean
    watchers: string[]
    auditors: string[]
    type: number
    // auto_approve_skipped_subtasks?: boolean
  }
  TIME_FRAME_SELECTION: TaskTimeFrame
}
